<div class="loading-indicator">
  <mat-progress-spinner mode="indeterminate" *ngIf="isLoading" bdColor="rgba(51,51,51,0.8)"></mat-progress-spinner>
</div>
<div class="bread-crumb-container d-flex justify-content-between align-items-center flex-wrap">
  <div >
    <h2 class="margin-0">Calendar</h2>
  </div>
  <div>
    <ul class="d-flex margin-0 legend-list flex-wrap">
      <li class="d-flex pd-r-10 mt-1">
        <div class="oz-color leg-box-width mr-r-5"></div>
        <div>Only zoom</div>
      </li>
      <li class="d-flex pd-r-10 mt-1">
        <div class="za-color leg-box-width mr-r-5"></div>
        <div>Zoom in Agora</div>
      </li>
      <li class="d-flex pd-r-10 mt-1">
        <div class="com-color leg-box-width mr-r-5"></div>
        <div>Completed</div>
      </li>
      <li class="d-flex pd-r-10 mt-1">
        <div class="past-color leg-box-width mr-r-5"></div>
        <div>Not held</div>
      </li>
      <li class="d-flex pd-r-10 mt-1">
        <div class="can-color leg-box-width mr-r-5"></div>
        <div>Cancelled</div>
      </li>
      <li class="d-flex pd-r-10 mt-1">
        <div class="task-color leg-box-width mr-r-5"></div>
        <div>Task</div>
      </li>
      <li class="d-flex pd-r-10 mt-1">
        <div class="sch-color leg-box-width mr-r-5"></div>
        <div>Scheduled</div>
      </li>
      <li class="d-flex pd-r-10 mt-1">
        <div class="bsch-color leg-box-width mr-r-5"></div>
        <div>Before scheduled</div>
      </li>
    </ul>
  </div>
</div>
<div class="wrapper" [id]="calendarId">
</div>